export const jobs = {
  description: "أعمال الإنتاج المخطّط لها والمُطلقة.",
  newJob: "أمر عمل جديد",
  searchHint: "يطابق العنوان أو الرقم.",
  emptyTitle: "لا توجد أوامر عمل مطابقة",
  emptyDescription: "أنشئ أمر عمل أو حوّل أمر بيع مقبولاً.",
  notFound: "أمر العمل غير موجود.",
  internalWork: "عمل داخلي",
  column: {
    job: "أمر عمل",
    due: "الاستحقاق",
  },
  filters: {
    allStatuses: "جميع الحالات",
    anyDueDate: "أي تاريخ استحقاق",
    overdue: "متأخر",
    dueSoon: "مستحق خلال 7 أيام",
  },
  meta: {
    quantity: "الكمية {quantity}",
    due: "الاستحقاق {date}",
  },
  create: {
    description: "النطاق وتاريخ الاستحقاق والعمليات المرتّبة التي تشكّل بطاقة التشغيل.",
    button: "إنشاء أمر العمل",
    noneInternal: "بدون (عمل داخلي)",
  },
  header: {
    back: "العودة إلى أوامر العمل",
  },
  action: {
    traveler: "بطاقة تشغيل",
    release: "إطلاق",
    hold: "تعليق",
    resume: "استئناف",
    ready: "جاهز",
    complete: "إكمال",
  },
  toast: {
    hold: "تم تعليق أمر العمل",
    released: "تم إطلاق أمر العمل",
    resumed: "تم استئناف أمر العمل",
    ready: "جاهز للتسليم",
    completed: "تم إكمال أمر العمل",
    cancelled: "تم إلغاء أمر العمل",
    created: "تم إنشاء أمر العمل",
  },
  holdModal: {
    title: "هل تريد تعليق أمر العمل هذا؟",
    hint: "مطلوب للسجل (بحد أدنى 3 أحرف).",
    confirm: "وضع قيد التعليق",
  },
  cancelModal: {
    title: "هل تريد إلغاء أمر العمل هذا؟",
    keep: "إبقاء أمر العمل",
    confirm: "إلغاء أمر العمل",
    reason: "السبب (اختياري)",
  },
  documents: {
    title: "الرسومات والمستندات",
    empty: "لا توجد رسومات مرفقة.",
    download: "تنزيل",
    attachLabel: "إرفاق رسم (PDF/صورة)",
    uploading: "جارٍ الرفع…",
    upload: "رفع",
    uploaded: "تم رفع المستند",
    removed: "تمت إزالة المستند",
  },
  history: {
    title: "السجل",
    empty: "لا يوجد سجل.",
  },
  issues: {
    title: "المشكلات",
    raise: "رفع مشكلة",
    empty: "لم يتم رفع أي مشكلات.",
    resolve: "حل",
    save: "حفظ المشكلة",
    severity: "الخطورة",
    whatsWrong: "ما المشكلة؟",
    resolvedAt: "تم الحل {date}",
    raisedToast: "تم رفع المشكلة",
    resolvedToast: "تم حل المشكلة",
    status: {
      open: "مفتوحة",
      resolved: "محلولة",
    },
  },
  materials: {
    title: "المواد",
    add: "إضافة مادة",
    empty: "لا توجد متطلبات مواد.",
    addedToast: "تمت إضافة المادة",
  },
  operations: {
    title: "العمليات",
    add: "إضافة عملية",
    operation: "العملية",
    empty: "لا توجد عمليات بعد.",
    noWorkCenter: "بدون مركز عمل",
    setup: "تجهيز {minutes} د",
    run: "تشغيل {minutes} د/وحدة",
    addedToast: "تمت إضافة العملية",
  },
};
